import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Helmet } from 'react-helmet/es/Helmet';
import { useDispatch } from 'react-redux';
import { propArrayShape, propId, propShape, propStr, } from '../../../../helpers/custom-prop-types';
import { compose } from '../../../../helpers/recompose';
import { useProfessionalSeminarEdit } from '../../../../helpers/use/professional_seminar/useProfessionalSeminarForm';
import { useUnmountRef } from '../../../../helpers/use/useHook';
import Layout from '../../../Layout';
import Breadcrumb from '../../../Layout/Breadcrumb';
import AuthenticationHoc from '../../../System/AuthenticationHoc';
import FinalForm from '../../../Ui/Common/FinalForm/FinalForm';
import SeminarHoc from '../Hoc/SeminarHoc';
import SeminarOneSkeleton from './Parts/SeminarOneSkeleton';
import SeminarOneSticky from './Parts/SeminarOneSticky';
import SeminarOneSubTitle from './Parts/SeminarOneSubTitle';
import SeminarOneTitle from './Parts/SeminarOneTitle';
const SeminarOne = (props) => {
    const { id, pageTitle, pans, profile, seminar } = props;
    const dispatch = useDispatch();
    const unmountRef = useUnmountRef();
    const { formSpyState: { error, submitting, validating, values }, initialValues, isCloning, isSelf, isUploading, onClickSave, onClone, onSubmit, renderForm, } = useProfessionalSeminarEdit({
        dispatch,
        id,
        profile,
        seminar,
        unmountRef,
    });
    return (_jsxs(Layout, Object.assign({ mainClassName: 'l-main professional_seminar_one', sticky: _jsx(SeminarOneSticky, { dataType: values ? values.dataType : undefined, id: id, isCloning: isCloning, isDisabled: validating || error || submitting || isUploading || isCloning, isSelf: isSelf, onClickSave: onClickSave, onClone: onClone, submitting: submitting }) }, { children: [_jsx(Helmet, { children: _jsx("title", { children: `${pageTitle}｜PROFFIT` }) }), _jsx(Breadcrumb, { lists: pans }), _jsx(SeminarOneTitle, { id: id, seminar: seminar }), _jsx(SeminarOneSubTitle, { isSelf: isSelf }), _jsx("div", Object.assign({ className: 'seminar_container' }, { children: _jsx(FinalForm, { initialValues: initialValues, onSubmit: onSubmit, render: renderForm }) }))] })));
};
SeminarOne.propTypes = {
    id: propId(),
    pageTitle: propStr().isRequired,
    pans: propArrayShape().isRequired,
    profile: propShape(),
    seminar: propShape(),
};
SeminarOne.defaultProps = {
    id: null,
    profile: {},
    seminar: {},
};
const enhance = compose(AuthenticationHoc({
    isCanUseProfessionalSeminar: true,
}), SeminarHoc({}, SeminarOneSkeleton));
export default enhance(SeminarOne);
